/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { SubtenantsPage } from '@/pages/Subtenants/SubtenantsPage';

export function SubtenantsRoute() {
  return <SubtenantsPage />;
}
